import React, { useMemo, useState } from "react";
import "./CenterTransfer.css";
import InnerHeader from "../../components/InnerHeader";
import BottomNav from "../../components/BottomNav/BottomNav";
import UserBalanceHero from "../../components/UserBalanceHero/UserBalanceHero";

export default function CenterTransfer({

  wallets = [
    { key: "main", label: "Main Account", balance: 0 },
    { key: "ninewickets", label: "9wickets", balance: 100 },
    { key: "kh3", label: "KH3 Poker", balance: 0 },
  ],
  transferRows = [
    {
      id: 1,
      type: "Transfer",
      time: "2026-02-05 16:20:14",
      from: "Main Account",
      to: "9wickets",
      amount: 100,
      status: "Confirm",
    },
  ],
  onSubmitTransfer,
}) {
  const [transActiveTab, setTransActiveTab] = useState("transfer");
  const [transFrom, setTransFrom] = useState("Main Account");
  const [transTo, setTransTo] = useState("Main Account");
  const [transAmount, setTransAmount] = useState("");

  const transMainWallet = useMemo(() => {
    return (
      wallets.find(
        (item) => item.label.toLowerCase() === "main account".toLowerCase()
      ) || wallets[0]
    );
  }, [wallets]);

  const transHandleSubmit = (e) => {
    e.preventDefault();

    if (!transAmount || Number(transAmount) <= 0) return;
    if (transFrom === transTo) return;

    if (onSubmitTransfer) {
      onSubmitTransfer({
        from: transFrom,
        to: transTo,
        amount: Number(transAmount),
      });
    }
  };

  return (
    <>
    <InnerHeader title="Center Transfer" />
    
    <div className="trans-wrap">
       <UserBalanceHero />

      <div className="trans-tab-row">
        <button
          type="button"
          className={`trans-tab-btn ${
            transActiveTab === "transfer" ? "trans-tab-btn--active" : ""
          }`}
          onClick={() => setTransActiveTab("transfer")}
        >
          Transfer
        </button>

        <button
          type="button"
          className={`trans-tab-btn ${
            transActiveTab === "list" ? "trans-tab-btn--active" : ""
          }`}
          onClick={() => setTransActiveTab("list")}
        >
          Transfer List
        </button>
      </div>

      {transActiveTab === "transfer" ? (
        <div className="trans-content">
          <div className="trans-wallet-lines">
            {wallets.map((item) => (
              <div className="trans-wallet-line" key={item.key}>
                {item.label}: {Number(item.balance).toFixed(2)}
              </div>
            ))}
          </div>

          <form className="trans-form" onSubmit={transHandleSubmit}>
            <div className="trans-field">
              <label className="trans-label">From:</label>
              <select
                className="trans-input"
                value={transFrom}
                onChange={(e) => setTransFrom(e.target.value)}
              >
                {wallets.map((item) => (
                  <option key={item.key} value={item.label}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="trans-field">
              <label className="trans-label">To:</label>
              <select
                className="trans-input"
                value={transTo}
                onChange={(e) => setTransTo(e.target.value)}
              >
                {wallets.map((item) => (
                  <option key={item.key} value={item.label}>
                    {item.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="trans-field">
              <label className="trans-label">Amount:</label>
              <input
                type="number"
                className="trans-input"
                value={transAmount}
                onChange={(e) => setTransAmount(e.target.value)}
                placeholder=""
              />
            </div>

            <button type="submit" className="trans-submit-btn">
              Submit
            </button>
          </form>
        </div>
      ) : (
        <div className="trans-content trans-content--list">
          <div className="trans-main-balance-strip">
            Main Account : {Number(transMainWallet?.balance || 0).toFixed(2)}
          </div>

          <div className="trans-table-wrap">
            <table className="trans-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Type</th>
                  <th>Time</th>
                  <th>From</th>
                  <th>To</th>
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>

              <tbody>
                {transferRows.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="trans-empty-row">
                      No record found!
                    </td>
                  </tr>
                ) : (
                  transferRows.map((row, index) => (
                    <tr key={row.id || index}>
                      <td>{index + 1}</td>
                      <td>{row.type}</td>
                      <td>{row.time}</td>
                      <td>{row.from}</td>
                      <td>{row.to}</td>
                      <td>{row.amount}</td>
                      <td>{row.status}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
    <BottomNav />
    </>
  );
}